import React, { useEffect, useState } from 'react'
//*Material
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import CardContent from '@material-ui/core/CardContent'
import Divider from "@material-ui/core/Divider"
import Button from "@material-ui/core/Button"
import { makeStyles } from '@material-ui/core/styles'
import Tab from "@material-ui/core/Tab"
import TabContext from "@material-ui/lab/TabContext"
import TabList from "@material-ui/lab/TabList"
import TabPanel from "@material-ui/lab/TabPanel"
import { Backdrop, CircularProgress, Link } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import AppBar from "@material-ui/core/AppBar"
import DataTable from 'react-data-table-component'
import IconButton from '@material-ui/core/IconButton'
import MoreVert from '@material-ui/icons/MoreVert'
//*antd
import Modal from 'antd/es/modal';
import Popover from 'antd/lib/popover'
//*Styles and Assets
import { TelematicsStyles } from './TelematicsStyles'
import { useTranslation } from 'react-i18next'
import PdfIcon from '../../assets/img/PdfIcon.svg'
//*Redux
import { connect } from "react-redux"
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import * as TelematicsActions from '../../actions/telematics/TelematicsActions'
import { Link as RouterLink } from 'react-router-dom'
//*Components
import TopBarNav from '../common/TopBarNav'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { customStyleSecondary } from '../common/CommonStyles'
import Constants from '../common/Constants.json'

const useStyles = makeStyles({
    stageButton: {
        backgroundColor: "#003E5E",
        color: "white"
    },
    denyButton: {
        backgroundColor: "white"
    },
    pdfButton: {
        backgroundColor: "white"
    },
    appbar: {
        backgroundColor: "White",

    },
    tab: {
        backgroundColor: '#A5A5A5',
        '&.Mui-selected': {
            backgroundColor: '#789AC1'
        },
        borderTopRigthRadius: "15%",
        textTransform: "initial"
    },
    indicator: {
        backgroundColor: "#7a9bc2"
    }
})

const InstallationOrderDetails = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const localclass = useStyles();
    const history = useHistory()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { match: { params } } = props;
    const [value, setValue] = useState(params.tabNumber);
    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/telematics/InstalationDetails',
            linkLegend: t('telematicsDetail.serviceDetails'),
            urlParams: [{ key: 'branchOfficeId', value: props.match.params.branchOfficeId }, { key: 'instalationId', value: props.match.params.instalationId }, { key: 'tabNumber', value: Constants.orderDetailsTelematics.InstallationOrder }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fecth_Installation_Order_Detail(props.userLanguage, props.userToken, props.match.params.branchOfficeId, props.match.params.instalationId, onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleDownload = () => {
        props.actions.Download_Order_Detail_PDF(props.userLanguage, props.userToken, props.match.params.branchOfficeId, props.match.params.instalationId, onError, onSuccessSave)
    }

    const handleAcceptOrder = (accept) => {
        var acceptObj = {
            "branchOfficeID": Number(props.match.params.branchOfficeId),
            "accept": accept
        }

        props.actions.accept_Installation_order(props.userLanguage, props.userToken, props.match.params.instalationId, acceptObj, onError, onSuccessSave)
    }

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onSuccessSave = (data) => {
        if (data.success) {
            Modal.success({
                title: t('commonMessages.updatedSucc')
            });
            history.push(`/telematics/${props.match.params.branchOfficeId}`);
        }
        else {
            Modal.error({
                title: t('telematicsErrors.AcceptOrDeclineInstallationOrderError'),
            })
        }
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const serviceColumns = [
        {
            name: t('telematicsDetail.serviceNumber'),
            selector: 'serviceRequestId',
            sortable: true,
            cell: row => row.serviceRequestId
        },
        {
            name: t('common.client'),
            selector: 'legalName',
            sortable: true,
            width: '250px',
            cell: row => row.legalName
        },
        {
            name: t('common.service'),
            selector: 'type_service',
            sortable: true,
            cell: row => row.type_service
        },
        {
            name: t('common.brand'),
            selector: 'brand',
            sortable: true,
            cell: row => row.brand
        },
        {
            name: t('common.model'),
            selector: 'model',
            sortable: true,
            cell: row => row.model
        },
        {
            name: "VIN",
            selector: 'vin',
            sortable: true,
            cell: row => row.vin
        },
        {
            name: t('common.status'),
            selector: 'nameStatusDesc',
            sortable: true,
            cell: row => row.nameStatusDesc
        },
        {
            name: t('telematicsDetail.rejectionComments'),
            selector: 'rejection_comments',
            sortable: true,
            cell: row => row.rejection_comments
        },
        {
            name: "",
            center: true,
            width: '60px',
            cell: row => (buttonForColumns(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.serviceRequestId
        }
    ]

    const buttonForColumns = (row) => {
        return (
            <div>
                {props.installationDetail.nameStatus === "EnProceso"
                    ?
                    <Popover
                        title=""
                        placement="bottomRight"
                        trigger="click"
                        content={
                            <div>
                                <div>
                                    <Link component={RouterLink} to={`/telematics/ServiceDetails/${props.match.params.branchOfficeId}&${props.installationDetail.installationOrderId}&${row.serviceRequestId}`}  >
                                        {t('telematicsDetail.serviceDetails')}
                                    </Link>
                                </div>
                                <div>
                                    <Link component={RouterLink} to={`/telematics/UploadEvidence/${props.match.params.branchOfficeId}&${row.serviceRequestId}&${row.type_service}&${props.match.params.instalationId}`} >
                                        {t('telematicsDetail.uploadEvidence')}
                                    </Link>
                                </div>
                            </div>
                        }>
                        <IconButton>
                            <MoreVert />
                        </IconButton>
                    </Popover>
                    :
                    <Popover
                        title=""
                        placement="bottomRight"
                        trigger="click"
                        content={
                            <div>
                                <div>
                                    <Link component={RouterLink} to={`/telematics/ServiceDetails/${props.match.params.branchOfficeId}&${props.installationDetail.installationOrderId}&${row.serviceRequestId}`}  >
                                        {t('telematicsDetail.serviceDetails')}
                                    </Link>
                                </div>
                            </div>
                        }>
                        <IconButton>
                            <MoreVert />
                        </IconButton>
                    </Popover>
                }
            </div>
        )
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} >
                        <p className={classes.titles}>{t(`telematicsDashboard.${props.installationDetail.nameStatus}`)}</p>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <TabContext value={value}>
                            <AppBar position="static" elevation={0}>
                                <TabList onChange={handleChange} className={localclass.appbar} TabIndicatorProps={{ className: localclass.indicator }} >
                                    <Tab label={t('telematicsDetail.installationOrder')} value="1" className={localclass.tab} />
                                    <Tab label={t('common.services')} value="2" className={localclass.tab} />
                                </TabList>
                            </AppBar>
                            <TabPanel value="1" className={classes.paddingTabPanel}>
                                <Container className={classes.generalBorder}>
                                    <CardContent>
                                        <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            alignItems="flex-start"
                                        >
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.instalationNumber')}</Typography>
                                                <Typography variant="body2">{props.installationDetail.installationOrderId}</Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.status')}</Typography>
                                                <Typography variant="body2">{props.installationDetail.statusDesc}</Typography>
                                            </Grid>
                                            <Grid item xs={7}>
                                                <br />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <CardContent>
                                        <Grid
                                            container
                                            direction="row"
                                            justify="space-between"
                                            alignItems="flex-start" >
                                            <Grid item xs={3}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }} >{t('telematicsColumns.instalationDate')}</Typography>
                                                <Typography variant="body2" >{props.installationDetail.installationOrderDate}</Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.creationDate')}</Typography>
                                                <Typography variant="body2">{props.installationDetail.createDate}</Typography>
                                            </Grid>
                                            <Grid item xs={7}>
                                                <br />
                                            </Grid>
                                        </Grid>
                                        <br />
                                    </CardContent>
                                    <Divider />
                                    <br />
                                    {
                                        props.installationDetail.nameStatus === "ConProveedor"
                                            ?
                                            <Grid container direction="row" justify="space-between" alignItems="flex-end" >
                                                <Grid item xs={7}>
                                                    <br />
                                                </Grid>
                                                <Grid item xs>
                                                    <Button onClick={() => handleAcceptOrder(true)} className={classes.generalBorder} variant="outlined">
                                                        {t('common.approve')}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs>
                                                    <Button onClick={() => handleAcceptOrder(false)} className={classes.generalBorder} variant="outlined">
                                                        {t('common.deny')}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Button onClick={handleDownload} className={classes.generalBorder} variant="outlined" fullWidth>
                                                        {t('commonMessages.dlPDF')}<img src={PdfIcon} alt="PDFIcon" width="24" height="24" />
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            :
                                            <Grid container direction="row" justify="space-between" alignItems="flex-end" >
                                                <Grid item xs={10}>
                                                    <br />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Button onClick={handleDownload} className={classes.generalBorder} variant="outlined" fullWidth>
                                                        {t('commonMessages.dlPDF')}<img src={PdfIcon} alt="PDFIcon" width="24" height="24" />
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                    }
                                    <br />
                                </Container>
                            </TabPanel>
                            <TabPanel value='2' className={classes.paddingTabPanel}>
                                <Container className={classes.generalBorder}>
                                    <br />
                                    <DataTable
                                        columns={serviceColumns}
                                        defaultSortField="installationOrderId"
                                        customStyles={customStyleSecondary}
                                        data={props.installationDetail.installationOrderServicesListDto}
                                        highlightOnHover
                                        pointerOnHover
                                        noHeader
                                        dense
                                        responsive
                                        striped
                                        pagination
                                        paginationComponentOptions={paginationOptions}
                                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                                    />
                                    {
                                        props.installationDetail.installationOrderServicesListDto && props.installationDetail.installationOrderServicesListDto.length < 1 && (
                                            <Grid container item xs={12}><br /></Grid>
                                        )
                                    }
                                </Container>
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    installationDetail: state.TelematicsReducer.installationOrderDetail,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(InstallationOrderDetails))
